<p-fileUpload
  name="file[]"
  [url]="fileUploadUrl"
  auto="auto"
  (onUpload)="onUpload($event)"
  (onBeforeSend)="onBeforeSend($event)"
  (onError)="onUploadError($event)"
  ngDefaultControl
  [accept]="accept"
  [headers]="appheaders"
  [chooseLabel]="uploadButtonLabel"
  [chooseIcon]="uploadButtonIcon"
  [maxFileSize]="maxSize"
  [invalidFileSizeMessageSummary]="maxSizeMessage">
</p-fileUpload>
<p-toast key="message"></p-toast>